export const microActivityList = "MICROACTIVITY_LIST";